export const LIVESTREAM_GENRES = alphabetizedWithOtherLast([
  { value: 'pop', label: 'Pop' },
  { value: 'dance', label: 'Dance' },
  { value: 'rap', label: 'Rap' },
  { value: 'jazz', label: 'Jazz' },
  { value: 'other', label: 'Muu' },
]);

const LANGUAGE_ENTRIES = [
  { value: 'en', label: 'English' },
  { value: 'bg', label: 'Bulgaria' },
  { value: 'hr', label: 'Kroatia' },
  { value: 'cs', label: 'Tšekki' },
  { value: 'da', label: 'Tanska' },
  { value: 'nl', label: 'Hollanti' },
  { value: 'et', label: 'Viro' },
  { value: 'fi', label: 'Suomi' },
  { value: 'fr', label: 'Ranska' },
  { value: 'de', label: 'Saksa' },
  { value: 'el', label: 'Kreikka' },
  { value: 'hu', label: 'Unkari' },
  { value: 'ga', label: 'Irlanti' },
  { value: 'it', label: 'Italia' },
  { value: 'lv', label: 'Latvia' },
  { value: 'lt', label: 'Liettua' },
  { value: 'mt', label: 'Malta' },
  { value: 'pl', label: 'Puola' },
  { value: 'pt', label: 'Portugali' },
  { value: 'ro', label: 'Romania' },
  { value: 'sk', label: 'Slovakia' },
  { value: 'sl', label: 'Slovenia' },
  { value: 'es', label: 'Espanja' },
  { value: 'sv', label: 'Ruotsi' },
  { value: 'other', label: 'Muu' },
];

/** English first, EU languages A–Ö (Finnish labels), Muu last. Kaikki is first in filter dropdowns only. */
export const LIVESTREAM_LANGUAGES = [
  LANGUAGE_ENTRIES.find((o) => o.value === 'en'),
  ...LANGUAGE_ENTRIES.filter((o) => o.value !== 'en' && o.value !== 'other').sort((a, b) =>
    a.label.localeCompare(b.label, 'fi'),
  ),
  LANGUAGE_ENTRIES.find((o) => o.value === 'other'),
];

function alphabetizedWithOtherLast(entries) {
  const other = entries.find((o) => o.value === 'other');
  const rest = entries
    .filter((o) => o.value !== 'other')
    .sort((a, b) => a.label.localeCompare(b.label, 'fi'));
  return other ? [...rest, other] : rest;
}

export function livestreamCategoryLabel(livestreamType, category) {
  if (!category) return '—';
  const list = livestreamType === 'talk' ? LIVESTREAM_LANGUAGES : LIVESTREAM_GENRES;
  return list.find((o) => o.value === category)?.label || category;
}
